import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Login from "./AdminPannel/Login";
import ContactForm from "./ContactForm/contactform";
import WebRegForm from "./ContactForm/webRegForm";
import Landing from "./AdminPannel/Landing";
import MainHeader from "./Header/MainHeader";
import Feedback from "./FeedbackPannel/Feedback";
import Main from "./Main/Main";
import RobatMaster from "./AdminPannel/RobotMaster";
import Feedbacktemplatemaster from "./AdminPannel/Feedbacktemplatemaster";

export default function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            padding: "12px 16px",
            borderRadius: "10px",
            fontSize: "14px",
            background: "#ffffff",
            color: "#334155",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          },

          success: {
            iconTheme: {
              primary: "#0fbc8c",
              secondary: "#ffffff",
            },
            style: {
              borderLeft: "5px solid #0fbc8c",
              animation: "toastSlideIn 0.5s ease-out",
            },
          },

          error: {
            iconTheme: {
              primary: "#ff4d4f",
              secondary: "#ffffff",
            },
            style: {
              borderLeft: "5px solid #ff4d4f",
              animation: "toastSlideIn 0.5s ease-out",
            },
          },

          loading: {
            style: {
              borderLeft: "5px solid #3b82f6",
              animation: "toastSlideIn 0.5s ease-out",
            },
          },
        }}
      />

      <Routes>
        <Route path="/Main" element={<Main />} />
        <Route path="/MainHeader" element={<MainHeader />} />
        <Route path="/Feedback" element={<Feedback />} />
        <Route path="/" element={<WebRegForm />} />
        <Route path="/ContactForm" element={<ContactForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/robatmaster" element={<RobatMaster />} />
        <Route
          path="/feedbacktemplatemaster"
          element={<Feedbacktemplatemaster />}
        />
      </Routes>
    </Router>
  );
}
